
export const responseToState = (response, params = {}, idSelector = item => item.id) => {
  const { data, meta } = response;
  const { current_page, total, per_page, last_page } = meta;
  const ids = data.map(idSelector);

  return {
    page: current_page,
    perPage: +per_page,
    lastPage: +last_page,
    total,
    search: params.search,
    ids
  };
};
